import { createAction, props } from '@ngrx/store';
import { Changelog } from './changelog.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records changelog',
    props<{ version: string }>()
    
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records changelog success', 
    props<{ listData: Changelog[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records changelog failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record changelog',
    props<{version: string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record changelog success', 
    props<{ singleData: Changelog }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record changelog failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record changelog',
    props<{ version: string, newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record changelog success'
);
export const addRecordFailure = createAction(
    '[Data] Add record changelog failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record changelog',
    props<{ version: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record changelog success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record changelog failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record changelog',
    props<{ version: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record changelog success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record changelog failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state changelog',
);